import { z } from 'zod';

export const BACKEND_VERSION_SCHEMA = z.object({
  version: z.string(),
});
export type BackendVersionResponse = z.infer<typeof BACKEND_VERSION_SCHEMA>;
